module.exports = __webpack_public_path__ + "h5/img/user.cde1d62b.png";